import { render, staticRenderFns } from "./memberrecord.vue?vue&type=template&id=4efe979e&scoped=true&"
import script from "./memberrecord.vue?vue&type=script&lang=js&"
export * from "./memberrecord.vue?vue&type=script&lang=js&"
import style0 from "./memberrecord.vue?vue&type=style&index=0&id=4efe979e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe979e",
  null
  
)

export default component.exports